//STYLES
import { useDispatch } from "react-redux";
import styles from "../NavBar.module.scss";

//TYPES
import { NavItem } from "../interfaces/types";

//DEPENDENCIES
import { useLocation, useNavigate } from "react-router-dom";

const NavItemLink = ({
  navItem,
  toggleMobileDrawer,
}: {
  navItem: NavItem;
  toggleMobileDrawer?: () => void;
}) => {
  const { selected, itemContainer, selectedBox, disabled } = styles;

  const { label, onClick, pathname, isDisabled } = navItem;

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const itemSelected = location.pathname === pathname;

  return (
    <div
      className={`${itemContainer} ${itemSelected ? selected : ""} ${isDisabled ? disabled : ""}`}
      onClick={() => {
        if (isDisabled) return;

        if (toggleMobileDrawer) toggleMobileDrawer();

        if (onClick) onClick(dispatch);
        else !!navItem.pathname && navigate(navItem.pathname);
      }}
    >
      <div className={selectedBox} />
      <span
        translate={
          navItem.translate === true || navItem.translate === undefined
            ? "yes"
            : "no"
        }
      >
        {label}
      </span>
    </div>
  );
};

export default NavItemLink;
